import { produce } from "immer";
import {
  LIST_SAFEGUARDING_REVIEWS,
  LIST_SAFEGUARDING_REVIEWS_SUCCESS,
  LIST_SAFEGUARDING_REVIEWS_FAILURE,
  LIST_SAFEGUARDING_CASES,
  LIST_SAFEGUARDING_CASES_SUCCESS,
  LIST_SAFEGUARDING_CASES_FAILURE,
  LIST_SAFEGUARDING_HISTORY,
  LIST_SAFEGUARDING_HISTORY_SUCCESS,
  LIST_SAFEGUARDING_HISTORY_FAILURE,
  GET_SAFEGUARDING_REVIEW,
  GET_SAFEGUARDING_REVIEW_SUCCESS,
  GET_SAFEGUARDING_REVIEW_FAILURE,
  CREATE_SAFEGUARDING_REVIEW,
  CREATE_SAFEGUARDING_REVIEW_SUCCESS,
  CREATE_SAFEGUARDING_REVIEW_FAILURE,
  PATCH_SAFEGUARDING_REVIEW,
  PATCH_SAFEGUARDING_REVIEW_SUCCESS,
  PATCH_SAFEGUARDING_REVIEW_FAILURE,
  ADD_SAFEGUARDING_NOTIFICATION,
  ADD_SAFEGUARDING_NOTIFICATION_SUCCESS,
  ADD_SAFEGUARDING_NOTIFICATION_FAILURE,
  LINK_SAFEGUARDING_RECORD,
  LINK_SAFEGUARDING_RECORD_SUCCESS,
  LINK_SAFEGUARDING_RECORD_FAILURE,
  RESOLVE_SAFEGUARDING_REVIEW,
  RESOLVE_SAFEGUARDING_REVIEW_SUCCESS,
  RESOLVE_SAFEGUARDING_REVIEW_FAILURE,
  LIST_LINKABLE_INCIDENTS,
  LIST_LINKABLE_INCIDENTS_SUCCESS,
  LIST_LINKABLE_INCIDENTS_FAILURE,
  LINK_SAFEGUARDING_INCIDENT,
  LINK_SAFEGUARDING_INCIDENT_SUCCESS,
  LINK_SAFEGUARDING_INCIDENT_FAILURE,
  UNLINK_SAFEGUARDING_INCIDENT,
  UNLINK_SAFEGUARDING_INCIDENT_SUCCESS,
  UNLINK_SAFEGUARDING_INCIDENT_FAILURE,
  GET_SAFEGUARDING_CASE,
  GET_SAFEGUARDING_CASE_SUCCESS,
  GET_SAFEGUARDING_CASE_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingReview: false,
  review: null,
  isListingReviews: false,
  reviews: [],
  isListingCases: false,
  cases: [],
  isListingHistory: false,
  history: [],
  isCreatingReview: false,
  isPatchingReview: false,
  isAddingNotification: false,
  isLinkingRecord: false,
  isResolvingReview: false,
  // Incident ↔ case linkage (real rd_incident_record rows, not alerts).
  isListingLinkableIncidents: false,
  linkableIncidents: [],
  isLinkingIncident: false,
  isUnlinkingIncident: false,
  linkedIncidents: [],
  // One event, several residents — the gathered case view.
  isFetchingCase: false,
  caseDetail: null,
};

const SafeguardingReviewReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List reviews
      case LIST_SAFEGUARDING_REVIEWS:
        draft.isListingReviews = true;
        break;
      case LIST_SAFEGUARDING_REVIEWS_SUCCESS:
        draft.isListingReviews = false;
        draft.reviews = action.payload;
        break;
      case LIST_SAFEGUARDING_REVIEWS_FAILURE:
        draft.isListingReviews = false;
        break;

      // List cases (link picker)
      case LIST_SAFEGUARDING_CASES:
        draft.isListingCases = true;
        break;
      case LIST_SAFEGUARDING_CASES_SUCCESS:
        draft.isListingCases = false;
        draft.cases = action.payload;
        break;
      case LIST_SAFEGUARDING_CASES_FAILURE:
        draft.isListingCases = false;
        break;

      // List history (enquiry link picker)
      case LIST_SAFEGUARDING_HISTORY:
        draft.isListingHistory = true;
        break;
      case LIST_SAFEGUARDING_HISTORY_SUCCESS:
        draft.isListingHistory = false;
        draft.history = action.payload;
        break;
      case LIST_SAFEGUARDING_HISTORY_FAILURE:
        draft.isListingHistory = false;
        break;

      // Get
      case GET_SAFEGUARDING_REVIEW:
        draft.isFetchingReview = true;
        break;
      case GET_SAFEGUARDING_REVIEW_SUCCESS:
        draft.isFetchingReview = false;
        draft.review = action.payload;
        break;
      case GET_SAFEGUARDING_REVIEW_FAILURE:
        draft.isFetchingReview = false;
        break;

      // Create
      case CREATE_SAFEGUARDING_REVIEW:
        draft.isCreatingReview = true;
        break;
      case CREATE_SAFEGUARDING_REVIEW_SUCCESS:
        draft.isCreatingReview = false;
        draft.review = action.payload;
        break;
      case CREATE_SAFEGUARDING_REVIEW_FAILURE:
        draft.isCreatingReview = false;
        break;

      // Patch (step save)
      case PATCH_SAFEGUARDING_REVIEW:
        draft.isPatchingReview = true;
        break;
      case PATCH_SAFEGUARDING_REVIEW_SUCCESS:
        draft.isPatchingReview = false;
        draft.review = action.payload;
        break;
      case PATCH_SAFEGUARDING_REVIEW_FAILURE:
        draft.isPatchingReview = false;
        break;

      // Add notification
      case ADD_SAFEGUARDING_NOTIFICATION:
        draft.isAddingNotification = true;
        break;
      case ADD_SAFEGUARDING_NOTIFICATION_SUCCESS:
        draft.isAddingNotification = false;
        draft.review = action.payload;
        break;
      case ADD_SAFEGUARDING_NOTIFICATION_FAILURE:
        draft.isAddingNotification = false;
        break;

      // Link record
      case LINK_SAFEGUARDING_RECORD:
        draft.isLinkingRecord = true;
        break;
      case LINK_SAFEGUARDING_RECORD_SUCCESS:
        draft.isLinkingRecord = false;
        draft.review = action.payload;
        break;
      case LINK_SAFEGUARDING_RECORD_FAILURE:
        draft.isLinkingRecord = false;
        break;

      // Resolve
      case RESOLVE_SAFEGUARDING_REVIEW:
        draft.isResolvingReview = true;
        break;
      case RESOLVE_SAFEGUARDING_REVIEW_SUCCESS:
        draft.isResolvingReview = false;
        draft.review = action.payload;
        break;
      case RESOLVE_SAFEGUARDING_REVIEW_FAILURE:
        draft.isResolvingReview = false;
        break;

      // Linkable incidents (the "+ Link an incident" picker)
      case LIST_LINKABLE_INCIDENTS:
        draft.isListingLinkableIncidents = true;
        break;
      case LIST_LINKABLE_INCIDENTS_SUCCESS:
        draft.isListingLinkableIncidents = false;
        draft.linkableIncidents = action.payload;
        break;
      case LIST_LINKABLE_INCIDENTS_FAILURE:
        draft.isListingLinkableIncidents = false;
        break;

      // Link / unlink an incident — both answer with the full linked set.
      case LINK_SAFEGUARDING_INCIDENT:
        draft.isLinkingIncident = true;
        break;
      case LINK_SAFEGUARDING_INCIDENT_SUCCESS:
        draft.isLinkingIncident = false;
        draft.linkedIncidents = action.payload;
        break;
      case LINK_SAFEGUARDING_INCIDENT_FAILURE:
        draft.isLinkingIncident = false;
        break;

      case UNLINK_SAFEGUARDING_INCIDENT:
        draft.isUnlinkingIncident = true;
        break;
      case UNLINK_SAFEGUARDING_INCIDENT_SUCCESS:
        draft.isUnlinkingIncident = false;
        draft.linkedIncidents = action.payload;
        break;
      case UNLINK_SAFEGUARDING_INCIDENT_FAILURE:
        draft.isUnlinkingIncident = false;
        break;

      // Case view (read-only gather)
      case GET_SAFEGUARDING_CASE:
        draft.isFetchingCase = true;
        break;
      case GET_SAFEGUARDING_CASE_SUCCESS:
        draft.isFetchingCase = false;
        draft.caseDetail = action.payload;
        break;
      case GET_SAFEGUARDING_CASE_FAILURE:
        draft.isFetchingCase = false;
        break;

      default:
        return state;
    }
  });

export default SafeguardingReviewReducer;
